import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { settings } from "settings";
import { permissionStore } from "store/permissionStore";
import { can, getToken } from "utils/auth";

const whileList = ["/login", "/connection-error"];

const canOpenPath = (pathname: string) => {
  if (!settings.checkPermission) return true;
  if (can(pathname, "VIEW")) return true;
  if (permissionStore.accessRoutes.some((route) => route.isPublic && route.path === pathname)) {
    return true;
  }
  if (pathname === "/opportunity/create") {
    return can("/opportunity", "VIEW");
  }
  if (/^\/opportunity\/\d+$/.test(pathname)) {
    return can("/opportunity", "VIEW") || can("/quote", "VIEW");
  }
  return permissionStore.accessRoutes.some(
    (route) => !!route.path && pathname.startsWith(`${route.path}/`) && can(route.path, "VIEW"),
  );
};

export const useRouter = (isLoaded: boolean) => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (!isLoaded) {
      return;
    }

    const token = getToken();

    if (!token) {
      return navigate("/login");
    }

    if (location.pathname == "/login" && token) {
      return navigate("/");
    }

    if (whileList.includes(location.pathname)) {
      return;
    }

    if (permissionStore.accessRoutes.length) {
      if (location.pathname == "/") {
        if (token) {
          navigate("/profile");
        } else {
          navigate("/login");
        }
      } else {
        if (
          settings.checkPermission &&
          !canOpenPath(location.pathname)
        ) {
          // debugger;
          navigate("/404");
        }
      }
    }

    handleScrollToTop();
  }, [location.pathname, isLoaded]);

  const handleScrollToTop = () => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  };

  return location;
};
